import iconLinkedin from "@/assets/img/author/linkedin.svg";
import iconInstagram from "@/assets/img/author/instagram.svg";
import iconWebsite from "@/assets/img/author/globe.svg";

const AUTHOR_LINK_ICONS = {
  linkedin: iconLinkedin,
  instagram: iconInstagram,
  website: iconWebsite,
};

const DATE_PATTERN = /^(\d{2})[.-](\d{2})[.-](\d{4})$/;

export const authorLinkIcon = type => AUTHOR_LINK_ICONS[type] || iconWebsite;

export const formatDate = date => {
  const match = DATE_PATTERN.exec(date || "");
  return match ? `${match[1]}.${match[2]}.${match[3]}` : date;
};

export const toIsoDate = date => {
  const match = DATE_PATTERN.exec(date || "");
  return match ? `${match[3]}-${match[2]}-${match[1]}` : date;
};
